import { useState } from 'react';
import { useFacility } from '../context/FacilityContext';
import customersService from '../services/customersService';

export const useCustomer = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { facilityId } = useFacility();

    const getCustomers = async (filters = {}) => {
        setLoading(true);
        try {
            const params = {};
            if (filters.search) params.search = filters.search;
            if (filters.include_archived) params.include_archived = true;
            if (filters.status) params.status = filters.status;
            const response = await customersService.getAll(facilityId, params);
            setError(null);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.detail || 'Failed to fetch customers');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const getCustomer = async (id) => {
        setLoading(true);
        try {
            const response = await customersService.getById(facilityId, id);
            setError(null);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.detail || 'Failed to fetch customer');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const createCustomer = async (data) => {
        setLoading(true);
        try {
            const response = await customersService.create(facilityId, data);
            setError(null);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.detail || 'Failed to create customer');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const updateCustomer = async (id, data) => {
        setLoading(true);
        try {
            const response = await customersService.update(facilityId, id, data);
            setError(null);
            return response.data;
        } catch (err) {
            setError(err.response?.data?.detail || 'Failed to update customer');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    const deleteCustomer = async (id) => {
        setLoading(true);
        try {
            await customersService.delete(facilityId, id);
            setError(null);
            return true;
        } catch (err) {
            setError(err.response?.data?.detail || 'Failed to delete customer');
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, getCustomers, getCustomer, createCustomer, updateCustomer, deleteCustomer };
};

export default useCustomer;
